import React, { Component } from 'react'
import { hideMessageModel } from '../../redux/actions/miscActions'
import { connect } from 'react-redux'
import { Modal, Spin } from 'antd';

export class MessageModal extends Component {
  
  handleCancel=()=>{
    const { messageType } = this.props.misc
    if(messageType !== 'loading'){
      this.props.hideMessageModel()
    }
  }

  render() {
    const { isMessageModalVisible, messageType, messageTxt } = this.props.misc
    return (
      <div className="message-modal-container">
        <Modal
          className="message-modal"
          centered={true}
          footer={null}
          visible={isMessageModalVisible}
          onCancel={this.handleCancel}
        >
          <div className="message-modal-content">
            {messageType === 'success' ? <i className="far fa-check-circle"></i> : null}
            {messageType === 'warning' ? <i className="fas fa-exclamation-triangle"></i>: null}
            {messageType === 'loading' ? <Spin /> : null}
            <p>{messageTxt}</p>
          </div>
        </Modal>
        
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  misc: state.misc
})

export default connect(mapStateToProps, { hideMessageModel })(MessageModal)
